<template>
  <div>
    <Spinner :fullscreen="true">
      <template v-slot:header
        >Login successful!</template
      >
      We are redirecting to your Dashboard for Autonomous System Health
    </Spinner>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import Spinner from '../components/ui/Spinner';
import router from '../router';

export default {
  methods: {
    ...mapActions('authStore', ['oidcSignInCallback']),
    ...mapMutations(['setTokenExpiredHandlerTimer'])
  },
  components: {
    Spinner
  },
  computed: {
    ...mapState(['tokenExpiredHandlerTimer'])
  },
  created() {
    this.oidcSignInCallback()
      .then(() => {
        // Read prev_path which was recorded before SSO login and redirect users to it.
        const path = sessionStorage.getItem('prev_path') || '/';
        router.push(path);
      })
      .catch(err => {
        console.error(err);
        // this.$router.push('/'); // Handle errors any way you want

        if (this.tokenExpiredHandlerTimer) {
          clearTimeout(this.tokenExpiredHandlerTimer);
          this.setTokenExpiredHandlerTimer(null);
        }
      });
  }
};
</script>
<style lang="scss"></style>
